<app-modal class="reasons-create-modal" [isLoading]="isLoading">
    <ng-container modal-header>
        <h5 class="modal-title" *ngIf="!isEditMode; else editTitle">
            {{ 'admin.reasons.modal.title.add' | translate }}</h5>
        <ng-template #editTitle>
            <h5 class="modal-title">{{ 'admin.reasons.modal.title.edit' | translate }}</h5>
        </ng-template>
    </ng-container>
    <div class="modal-body" modal-body>
        <form [formGroup]="reasonForm">
            <app-input formControlName="name"
                       [formControl]="reasonForm.controls['name']"
                       [showErrors]="showValidations"
                       placeholder="{{'admin.reasons.modal.name.placeholder' | translate }}"
                       label="{{'admin.reasons.modal.name.label' | translate}}">
            </app-input>
            <app-dropdown formControlName="scope"
                          [formControl]="reasonForm.controls['scope']"
                          [items]="scopeOptions"
                          valueField="value"
                          displayField="name"
                          [showErrors]="showValidations"
                          emptyText="{{'admin.reasons.modal.scope.placeholder' | translate }}"
                          label="{{'admin.reasons.modal.scope.label' | translate}}">
            </app-dropdown>
        </form>
    </div>
    <div class="footer" modal-footer>
        <app-button type="simple"
                    [disabled]="isLoading"
                    (click)="modal.close()">
            {{ 'generic.buttons.close' | translate }}
        </app-button>
        <div class="mutators">
            <app-button *ngIf="!isEditMode && shouldRenderModifiers()"
                        type="primary"
                        [disabled]="isLoading"
                        (click)="createReason()">
                {{ 'generic.buttons.create'| translate }}
            </app-button>
            <app-button *ngIf="isEditMode && shouldRenderModifiers()"
                        type="warning"
                        [disabled]="isLoading"
                        (click)="updateReason()">
                {{ 'generic.buttons.update'| translate }}
            </app-button>
            <app-button type="danger"
                        *ngIf="isEditMode && shouldRenderModifiers()"
                        [disabled]="reason.inUse || isLoading"
                        (click)="deleteReason()">
                {{ 'generic.buttons.delete' | translate }}
            </app-button>
        </div>
    </div>
</app-modal>
